import SiteMessagesInstance from './site-messages';

class UserNotices {

  constructor () {
    this.notices = [];
  }

  getNotices() {

    return new Promise((resolve, reject) => {

      window.apiRequest('get', '/user/notices').then(r => {

        if(r.type === 'success') {
          this.notices = r.data;
        }

        resolve();

      });

    });

  }

  showNotices() {

    if(this.notices.length > 0) {

      this.notices.forEach(notice => {
        SiteMessagesInstance.addMessage(notice.type, notice.message, {
          autoClose: 0,
        })
      });

      SiteMessagesInstance.displayMessages();

    }

  }

}

const UserNoticesInstance = new UserNotices();

export default UserNoticesInstance;
